import { Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import Import from "../Assets/svg/heading-svg/Button.svg";
import Create from "../Assets/svg/heading-svg/Button (2).svg";
import UserSettings from "../Assets/svg/heading-svg/user-settings-icon.svg";
import CustomExportModal from "../components/Common/CustomExportFileModal";
import { useState } from "react";
import CustomImportFileModal from "../components/Common/CustomImportFileModal";
import CustomMultipleFileModal from "../components/Common/CustomMultiPleFileModal";

// custom map array for import map header

const mappedArrayForProduct = [
  {
    label: "type",
    value: "type",
  },
  {
    label: "code",
    value: "code",
  },
  {
    label: "name",
    value: "name",
  },
  {
    label: "brand",
    value: "brand",
  },
  {
    label: "quantity",
    value: "quantity",
  },
  {
    label: "modelNumber",
    value: "model_number",
  },
  {
    label: "batchNumber",
    value: "batch_number",
  },
  {
    label: "barcode",
    value: "barcode",
  },
  {
    label: "kitBarcode",
    value: "kit_barcode",
  },
  {
    label: "picture",
    value: "picture",
  },
  {
    label: "description",
    value: "description",
  },
];

// const mappedArrayForKits = [
//   {
//     label: " Product Name",
//     value: "product_name",
//   },
//   {
//     label: "Product Code",
//     value: "product_code",
//   },
//   {
//     label: "UAN Number",
//     value: "kit_ref_id",
//   },
//   {
//     label: "Registered Date",
//     value: "registered",
//   },
//   {
//     label: "Kit Picture",
//     value: "kit_picture",
//   },
//   {
//     label: "QR Code",
//     value: "qr_code",
//   },
//   {
//     label: "Quantity",
//     value: "quantity",
//   },
//   {
//     label: "Brand",
//     value: "brand",
//   },
//   {
//     label: "Location",
//     value: "location_name",
//   },
//   {
//     label: "Area",
//     value: "area",
//   },
//   {
//     label: "Batch Number  ",
//     value: "batch_number",
//   },
//   {
//     label: "LOT Number",
//     value: "lot_number",
//   },
//   {
//     label: "Expiry Date",
//     value: "expiry_date",
//   },
//   {
//     label: "Status",
//     value: "status",
//   },
//   // {
//   //   label: "Status",
//   //   value: "status",
//   // },
// ];

const mappedArrayForUser = [
  // {
  //   label: "Skip",
  //   value: "skip",
  // },
  {
    label: "FirstName",
    value: "first_name",
  },
  {
    label: "LastName",
    value: "last_name",
  },
  {
    label: "Email",
    value: "email",
  },
  {
    label: "ContactNumber",
    value: "contact_number",
  },
  {
    label: "CountryCode",
    value: "country_code",
  },

  {
    label: "ProfilePicUrl",
    value: "profile_pic",
  },
  {
    label: "IsMentallyFit",
    value: "is_mentally_fit",
  },
  {
    label: "JobTitle",
    value: "job_title",
  },
  // {
  //   label: "Firstaid Certificate",
  //   value: "firstaid_certificate",
  // },
  // {
  //   label: "FirstaidCertificate Date",
  //   value: "firstaid_certificate_date",
  // },

  {
    label: "AssignedRole",
    value: "assigned_role",
  },
  // {
  //   label: "Permissions",
  //   value: "permissions",
  // },
];

const mappedArrayForDistributor = [
  {
    label: "Skip",
    value: "skip",
  },
  {
    label: "Distributor Name",
    value: "distributor_name",
  },
  {
    label: "Street",
    value: "street",
  },
  {
    label: "County",
    value: "county",
  },
  {
    label: "Country",
    value: "country",
  },
  {
    label: "Email",
    value: "email",
  },
  {
    label: "Postal Code",
    value: "postal_code",
  },
  {
    label: "Country Code",
    value: "country_code",
  },
  {
    label: "Contact Number",
    value: "contact_number",
  },
  {
    label: "Company Logo",
    value: "company_logo",
  },
  {
    label: "Company White Logo",
    value: "company_white_logo",
  },
  {
    label: "Alternate Distributor Name",
    value: "alternate_distributor_name",
  },
  {
    label: "Role",
    value: "role",
  },
];

export const createMenus = {
  "/": null,
  "/businessprofile": null,
  "/products": [
    // {
    //   title: "Create Products",
    //   icon: <img src={Create} alt="Product Icon" />,
    //   link: "",
    // },
    {
      title: "Import Products",
      icon: <img src={Import} alt="Import Icon" />,
      link: "",
      modalName: "Import",
      mapArray: mappedArrayForProduct,
      csvTitle: "Reliance_Import_Kit_And_Products",
    },
    // {
    //   title: "Export Products",
    //   icon: <img src={Export} alt="Export Icon" />,
    //   link: "",
    //   modalName: "Export",
    //   mapArray: mappedArrayForProduct,
    // },
  ],
  "/kit": [
    {
      title: "Create Batch Kits",
      icon: <img src={Create} alt="Kit Icon" />,
      link: "/createkit",
    },
    // {
    //   title: "Import Kits",
    //   icon: <img src={Import} alt="Import Icon" />,
    //   link: "",
    // },
    // {
    //   title: "Export Kits",
    //   icon: <img src={Export} alt="Export Icon" />,
    //   link: "",
    //   modalName: "Export",
    // },
    {
      title: "Create Empty Kits",
      icon: <img src={Create} alt="Kit Icon" />,
      link: "/createemptykit",
    },
    // Don't
    // {
    //   title: "Export Kits",
    //   icon: <img src={Export} alt="Export Icon" />,
    //   link: "",
    //   modalName: "Export",
    //   mapArray: mappedArrayForKits,
    // },
  ],
  "/users": [
    // {
    //   title: "Invite Admin",
    //   icon: <img src={Invite} alt="User Icon" />,
    //   link: "/user-management",
    // },
    // {
    //   title: "Invite Admin",
    //   icon: <img src={UserSettings} alt="User Settings" />,
    //   link: "/users",
    // },
    {
      title: "Create User",
      icon: <img src={Import} alt="User Settings" />,
      link: "/create-users",
    },
    // {
    //   title: "Import Users",
    //   icon: <img src={Import} alt="Import Icon" />,
    //   link: "",
    //   modalName: "Import",
    //   mapArray: mappedArrayForUser,
    //   csvTitle: "Reliance_Import_User",
    // },
    // {
    //   title: "Export Users",
    //   icon: <img src={Export} alt="Export Icon" />,
    //   link: "",
    //   modalName: "Export",
    //   mapArray: mappedArrayForUser,
    // },
  ],
  "/distributors": [
    {
      title: "Create Distributor",
      icon: <img src={Create} alt="Distributor Icon" />,
      link: "/distributorinfo",
    },
    // {
    //   title: "Import Distributors",
    //   icon: <img src={Import} alt="Import Icon" />,
    //   link: "",
    //   modalName: "Import",
    //   mapArray: mappedArrayForDistributor,
    //   csvTitle: "Reliance_Import_Distributor",
    // },
    // {
    //   title: "Export Distributors",
    //   icon: <img src={Export} alt="Export Icon" />,
    //   link: "",
    //   modalName: "Export",
    //   mapArray: mappedArrayForDistributor,
    // },
  ],
  "/reports": [
    {
      title: "Create Report",
      icon: <img src={Create} alt="Report Icon" />,
      link: "/reporteditor",
    },
    {
      title: "Create Group",
      icon: <img src={Create} alt="Create Group Icon" />,
      link: "/creategroupreport",
    },
  ],
  // "/resource": [
  //   {
  //     title: "Upload Files",
  //     icon: <img src={Create} alt="Resource Icon" />,
  //     link: "",
  //     modalName: "UploadMultiple",
  //   },
  // ],
  "/messaging": [
    // {
    //   title: "Create article",
    //   icon: <img src={Create} alt="Messaging Icon" />,
    //   link: "/editarticle",
    // },
    {
      title: "Create Notification",
      icon: <img src={Create} alt="Create Notification Icon" />,
      link: "/edit-notification",
    },
  ],

  "/distributor-user-management": [
    // {
    //   title: "Invite Admin",
    //   icon: <img src={UserSettings} alt="User Icon" />,
    //   link: "/distributor-user-management",
    // },
    // {
    //   title: "Import Users",
    //   icon: <img src={Import} alt="Import Icon" />,
    //   link: "",
    //   modalName: "Import",
    //   mapArray: mappedArrayForDistributor,
    // },
    {
      title: "Create User",
      icon: <img src={Create} alt="User Icon" />,
      link: "/distributor-create-user",
    },
    // {
    //   title: "Export Users",
    //   icon: <img src={Export} alt="Export Icon" />,
    //   link: "",
    //   modalName: "Export",
    //   mapArray: mappedArrayForDistributor,
    // },
  ],
  "/distributor-clients": [
    // {
    //   title: "Invite Customer",
    //   icon: <img src={Create} alt="User Icon" />,
    //   link: "/distributor-clients",
    // },
  ],

  // custom distributor

  "/notifications": null,
};

const CreateActions = ({
  title,
  icon,
  link,
  modalName,
  mapArray,
  csvTitle,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showMultipleFileModal, setShowMultipleFileModal] = useState(false);

  return (
    <div className="top-btns">
      <Card style={{ borderRadius: 16, border: "none" }}>
        {!link ? (
          <Button
            variant="primary"
            className="icon-button column-gap-2"
            onClick={() => {
              if (modalName === "Import") {
                setShowImportModal(true);
              } else if (modalName === "Export") {
                setShowModal(true);
              }
              if (modalName === "UploadMultiple") {
                setShowMultipleFileModal(true);
              }
            }}
          >
            {icon}
            <h3 className="button-text m-0">{title}</h3>
          </Button>
        ) : (
          <Link to={link} style={{ textDecoration: "none", color: "inherit" }}>
            <Button variant="primary" className="icon-button column-gap-2">
              {icon}
              <h3 className="button-text m-0">{title}</h3>
            </Button>
          </Link>
        )}
      </Card>
      {showModal && (
        <CustomExportModal
          icon={icon}
          show={showModal}
          hide={setShowModal}
          heading={title}
          mapArray={mapArray}
        />
      )}
      {showImportModal && (
        <CustomImportFileModal
          csvTitle={csvTitle}
          icon={icon}
          show={showImportModal}
          hide={setShowImportModal}
          heading={title}
          mapArray={mapArray}
        />
      )}

      {showMultipleFileModal && (
        <CustomMultipleFileModal
          icon={icon}
          show={showMultipleFileModal}
          hide={setShowMultipleFileModal}
          heading={title}
        />
      )}
    </div>
  );
};

const RenderCreateMenus = ({ pathname }) => {
  return (
    <div className="kits_row px-0">
      {createMenus[pathname].map((menuItem, i) => {
        return (
          <CreateActions
            key={i}
            title={menuItem.title}
            icon={menuItem.icon}
            link={menuItem.link !== "" ? menuItem.link : null}
            modalName={menuItem.modalName}
            mapArray={menuItem?.mapArray}
            csvTitle={menuItem?.csvTitle}
          />
        );
      })}
    </div>
  );
};

export default RenderCreateMenus;
